import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import SideMenu from "./SideMenu";

interface PropType {}

interface StateType {
  activateSideMenu: boolean;
  activateSearch: boolean;
}

const Header: React.FC<PropType> = (props) => {
  const [activateSideMenu, setActivateSideMenu] = useState(false);
  const [activateSearch, setActivateSearch] = useState(false);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickSideMenu = (e: any) => {
    e.preventDefault();
    setActivateSideMenu(!activateSideMenu);
  };

  const getMenuActiveStatus = (status: boolean) => {
    setActivateSideMenu(status);
  };

  // Function to handle clicks outside the side menu
  const handleClickOutside = (event: MouseEvent) => {
    const sideMenuTrigger = document.querySelector(".header-menu-trigger");
    if (!sideMenuTrigger || !sideMenuTrigger.contains(event.target as Node)) {
      // Clicked outside the side menu trigger, close the side menu
      setActivateSideMenu(false);
    }
  };

  return (
    <header>
      <div className="header-wrapper border-bottom">
        <div className="container space-y--15">
          <div className="row justify-content-between">
            <div className="col-auto">
              {/* header logo */}
              <div className="header-logo">
                <Link to={process.env.PUBLIC_URL + "/home"}>
                  <img
                    src={process.env.PUBLIC_URL + "/assets/img/logo.png"}
                    className="img-fluid"
                    alt=""
                    width={35}
                  />
                </Link>
              </div>
            </div>
            <div className="col-auto">
              {/* header menu trigger */}
              <button
                className="header-menu-trigger"
                onClick={(e) => handleClickSideMenu(e)}
              >
                <ReactSVG
                  src={process.env.PUBLIC_URL + "/assets/img/icons/menu.svg"}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* side menu */}
      <SideMenu show={activateSideMenu} activeStatus={getMenuActiveStatus} />
    </header>
  );
};

export default Header;
